var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable react/prop-types */
import React, { forwardRef } from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import { VisuallyHidden } from '../VisuallyHidden';
import { actionIconDefaultProps } from './props';
import * as Styles from './styles';
const Label = _ref => {
  let {
    hideVisibleLabel,
    widthLabel,
    label
  } = _ref;
  return hideVisibleLabel ? React.createElement(VisuallyHidden, null, label) : React.createElement(Styles.Label, {
    className: "ds-icon-action-label",
    width: widthLabel,
    marginTop: "--spacing-1"
  }, label);
};
/**
 * Componente IconAction do Design System OLX
 */
export const IconAction = forwardRef((_a, ref) => {
  var {
      bgColor,
      href,
      icon,
      label,
      hideVisibleLabel,
      widthLabel,
      isLoading,
      disabled,
      interactive = actionIconDefaultProps.interactive,
      size = actionIconDefaultProps.size,
      notification
    } = _a,
    props = __rest(_a, ["bgColor", "href", "icon", "label", "hideVisibleLabel", "widthLabel", "isLoading", "disabled", "interactive", "size", "notification"]);
  return React.createElement(Styles.IconActionWrapper, Object.assign({
    "data-ds-component": "DS-IconAction",
    ref: ref
  }, href && {
    href,
    as: 'a'
  }, {
    className: "".concat(interactive ? 'interactive' : '', " ").concat(isLoading ? 'loading' : '')
  }, !href && {
    disabled
  }, props), React.createElement(Styles.IconWrapper, Object.assign({
    "aria-hidden": "true",
    "data-testid": "ds-link-icon-wrapper",
    className: "ds-link-icon-wrapper ".concat(size, " ").concat(notification ? 'has-notification' : '')
  }, !!notification && {
    'data-notification': notification > 9 ? '+9' : notification
  }, {
    style: Object.assign({}, bgColor && {
      backgroundColor: "var(".concat(bgColor, ")")
    })
  }), isLoading ? React.createElement(Styles.Spinner, {
    color: "--color-neutral-70",
    size: size,
    "aria-label": label
  }) : icon), React.createElement(Label, {
    hideVisibleLabel: hideVisibleLabel,
    widthLabel: widthLabel,
    label: label
  }));
});
IconAction.displayName = 'IconAction';